export enum Pathname {
    RETAIL = "retail",
    SME = "sme", // CustomerType BIC, BA, BNC
    FLEET = "fleet", // CustomerType PM
}